<h2>QN SBN eservice component</h2>


<!-- TODO Fix everything -->
        <mat-list-item routerLink="/create-notification" [routerLinkActive]="['is-active']">
          <div style="margin-left: 15px;">
            Create Notification
          </div>
        </mat-list-item>
        <mat-list-item routerLink="/create-notification" [routerLinkActive]="['is-active']">
          <div style="margin-left: 15px;">
            Audit Trail
          </div>
        </mat-list-item>
